import { render } from "./Celebration.vue?vue&type=template&id=78a9b8d8&scoped=true"
import script from "./Celebration.vue?vue&type=script&lang=js"
export * from "./Celebration.vue?vue&type=script&lang=js"

import "./Celebration.vue?vue&type=style&index=0&id=78a9b8d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a9b8d8"]])

export default __exports__